/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class BaseDataApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `BaseDataApiModule.forRoot()`
 */
export interface BaseDataApiConfigurationParams {
  rootUrl?: string;
}
